module.exports = __webpack_public_path__ + "img/icon-q.faf526e8.svg";